<!--
  app/components/pages/how-to-play/HtpSectionChrono.vue
-->
<script setup lang="ts">
import { useNuxtApp } from "#imports";
import ContextLogoCrown from "~/components/context-shared/ContextLogoCrown.vue";

const { $t } = useNuxtApp();
</script>

<template>
  <section id="match-chrono" class="scroll-mt-48">
    <div
      class="flex flex-col bigsm:flex-row bigsm:items-baseline gap-1 bigsm:gap-4 mb-6 pb-2 bigsm:border-b bigsm:border-gray-700"
    >
      <div
        class="flex items-baseline gap-3 shrink-0 border-b border-gray-700 pb-2 bigsm:pb-0 bigsm:border-none"
      >
        <span class="text-primary shrink-0 self-center"><ContextLogoCrown :width="28" :height="28" /></span>
        <h2 class="font-kings text-3xl bigsm:text-4xl uppercase">
          {{ $t("howToPlay.section.chrono.title") }}
        </h2>
      </div>
    </div>

    <div class="flex justify-center items-center flex-wrap gap-4">
      <NuxtImg
        src="/img/htp/chrono/scoreboard.png"
        alt=""
        aria-hidden="true"
        width="448"
        height="103"
        format="webp"
        loading="lazy"
        class="w-full max-w-sm bigsm:max-w-md h-auto object-contain rounded-lg"
      />

      <NuxtImg
        src="/img/htp/chrono/chrono.png"
        alt=""
        aria-hidden="true"
        width="448"
        height="103"
        format="webp"
        loading="lazy"
        class="w-full max-w-sm bigsm:max-w-md h-auto object-contain rounded-lg"
      />
    </div>

    <!-- Description + photo -->
    <div class="flex flex-col sm:flex-row items-center gap-5 bigsm:gap-8 mb-8 px-6">
      <p class="flex-1 text-gray-300">
        {{ $t("howToPlay.section.chrono.description") }}
      </p>
    </div>

    <!-- When does the clock stop -->
    <div class="px-6">
      <h3 class="text-primary text-base bigsm:text-lg font-semibold mb-2">
        {{ $t("howToPlay.section.chrono.stops.title") }}
      </h3>
      <ul class="space-y-1 bigsm:space-y-3 mb-4 bigsm:mb-8">
        <li v-for="n in 4" :key="n" class="flex gap-2 items-start">
          <span class="text-primary shrink-0 font-kings">—</span>
          <span class="text-gray-300">
            {{ $t(`howToPlay.section.chrono.stops.rule${n}`) }}
          </span>
        </li>
      </ul>
    </div>

    <!-- Sanction chrono -->
    <div class="px-4 bigsm:px-6">
      <h3 class="text-primary text-base bigsm:text-lg font-semibold mb-2">
        {{ $t("howToPlay.section.sanctionsChrono.title") }}
      </h3>
      <p class="flex-1 text-gray-300">
        {{ $t("howToPlay.section.sanctionsChrono.description") }}
      </p>
    </div>
  </section>
</template>
